import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var CollisionsAbsorb = /*#__PURE__*/function () {
  function CollisionsAbsorb() {
    _classCallCheck(this, CollisionsAbsorb);

    this.speed = 2;
  }

  _createClass(CollisionsAbsorb, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.speed !== undefined) {
        this.speed = data.speed;
      }
    }
  }]);

  return CollisionsAbsorb;
}();